import { render, staticRenderFns } from "./mineMain.vue?vue&type=template&id=3ef65f81&scoped=true&"
import script from "./mineMain.vue?vue&type=script&scoped=true&lang=js&"
export * from "./mineMain.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./mineMain.vue?vue&type=style&index=0&id=3ef65f81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef65f81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef65f81')) {
      api.createRecord('3ef65f81', component.options)
    } else {
      api.reload('3ef65f81', component.options)
    }
    module.hot.accept("./mineMain.vue?vue&type=template&id=3ef65f81&scoped=true&", function () {
      api.rerender('3ef65f81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/mineMain.vue"
export default component.exports